import { Timestamp } from "@firebase/firestore";

export const getTimestampFromApi = (timestamp: {
  _seconds: number;
  _nanoseconds: number;
}) => {
  return new Timestamp(timestamp._seconds, timestamp._nanoseconds);
};
